import { render, staticRenderFns } from "./AccountBackofficeList.vue?vue&type=template&id=81642aec&"
import script from "./AccountBackofficeList.vue?vue&type=script&lang=js&"
export * from "./AccountBackofficeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports